// src/components/common/ContentFilters.js

import React from 'react';

/**
 * کامپوننت UI برای اعمال مرتب‌سازی و فیلترها روی محتوای لیست
 * @param {object} filters - آبجکت شامل: {sortOrder, isFree}
 * @param {function} setFilters - تابع برای به‌روزرسانی فیلترها
 */
const ContentFilters = ({ filters, setFilters }) => {

    const handleSortChange = (e) => {
        setFilters(prev => ({ 
            ...prev, 
            sortOrder: e.target.value 
        }));
    };

    const handleFreeFilterChange = () => {
        setFilters(prev => ({ 
            ...prev, 
            // اگر رایگان بود، آن را حذف کن (null)، در غیر این صورت آن را فعال کن (true)
            isFree: prev.isFree === true ? null : true 
        }));
    };
    
    // 💡 نکته: فیلتر contentType در این درخواست استفاده نشده و حذف شد.

    return (
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center 
                        p-4 bg-gray-50 border-b border-gray-200 sticky top-0 z-20 mx-auto max-w-[460px] w-full rtl">
            
            {/* ۱. مرتب سازی (Sort) */}
            <div className="flex items-center space-x-reverse space-x-2 mb-3 sm:mb-0">
                <label 
                    htmlFor="sort-order" 
                    className="text-xs font-medium text-gray-700 flex-shrink-0"
                >
                    مرتب‌سازی:
                </label>
                <select
                    id="sort-order"
                    value={filters.sortOrder}
                    onChange={handleSortChange}
                    className="p-1 text-xs font-medium text-gray-800 border border-gray-300 rounded-md 
                               focus:ring-indigo-500 focus:border-indigo-500"
                >
                    {/* ✅ مرتب سازی بر اساس جدیدترین */}
                    <option value="newest">جدیدترین</option>
                    {/* ✅ مرتب سازی بر اساس لایک */}
                    <option value="likes">تعداد لایک</option>
                </select>
            </div>

            {/* ۲. فیلتر رایگان (Toggle) */}
            <div className="flex items-center space-x-reverse space-x-2 cursor-pointer" onClick={handleFreeFilterChange}>
                <input
                    id="is-free-filter"
                    type="checkbox"
                    checked={filters.isFree === true}
                    onChange={() => {}} // هندل شدن کلیک توسط div والد
                    className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
                <label 
                    htmlFor="is-free-filter" 
                    className={`text-xs font-medium select-none ${
                        filters.isFree === true ? 'text-indigo-600' : 'text-gray-700'
                    }`}
                >
                    محتوای رایگان
                </label>
            </div>

        </div>
    );
};

export default ContentFilters;